module.exports = __webpack_public_path__ + "img/low hips.c8a1e775.png";